<template>
  <div id="blank-layout">
    <StatusBanner :variantPayload="bannerPayload" />
    <slot />
  </div>
</template>

<script>
import StatusBanner from '@/components/StatusBanner';
import { getUnleashVariant } from '@/lib/unleash';

export default {
  components: {
    StatusBanner
  },
  data() {
    return {
      bannerPayload: null
    };
  },
  async created() {
    try {
      const variant = getUnleashVariant('status-banner');
      if (variant?.payload?.value) {
        this.bannerPayload = JSON.parse(variant.payload.value);
      } else {
        console.log('[StatusBanner] No variant payload found');
      }
    } catch (err) {
      console.warn('Invalid Unleash banner payload:', err);
    }
  }
};
</script>
